import { usingPost } from '@ocean/api'
import { AssessmentRecord } from 'modules/simulatorTrainings/instructor/instructorLed/TrainingDetails/types'

export const assessSimulatorTrainingScheduleParticipants = (
  scheduleId: Guid,
  selectedAssessments: AssessmentRecord
) => {
  const assessments = Object.keys(selectedAssessments).map(userId => ({
    userId,
    status: selectedAssessments[userId],
  }))
  return usingPost('SimulatorTrainings/AssessSimulatorTrainingScheduleParticipants', {
    scheduleId,
    assessments,
  })
}
